import { getModeDisplay, type ModeDisplay } from '@/utils/appMode';

/**
 * The values the build injected into this bundle (rulebook §8): the only
 * module in `src/` that reads `process.env`. Each read is the literal
 * `process.env.BUN_PUBLIC_*` the build's `define` replaces (src/clientBuild.ts),
 * so it becomes a constant. Tests replace this module (`vi.mock('@/config/env')`)
 * rather than the process environment.
 *
 * Remaining direct readers predating this module are registered in
 * `.agents/frontend.md` (§8).
 */

/** Whether this bundle is a development build (`local` or `development`). */
const IS_DEVELOPMENT_BUILD =
    process.env.BUN_PUBLIC_BOS_MODE === 'local' ||
    process.env.BUN_PUBLIC_BOS_MODE === 'development';

/**
 * Loads React Query devtools in a development build; `null` in production.
 *
 * The condition repeats the comparison above on purpose. Bun folds a
 * comparison of an injected value to a constant, but not a constant imported
 * from another module, and only a folded `false` drops the import (and its
 * chunk) from a production bundle.
 */
export const loadQueryDevtools =
    process.env.BUN_PUBLIC_BOS_MODE === 'local' ||
    process.env.BUN_PUBLIC_BOS_MODE === 'development'
        ? () => import('@tanstack/react-query-devtools')
        : null;

export type Env = Readonly<{
    /** The run mode the bundle was built for; `undefined` outside a build. */
    mode: string | undefined;
    /** The API address, e.g. `https://dev-api.bos.plus/`. */
    apiBaseUrl: string;
    /** The git commit, or `''` when the build was not given one. */
    buildCommit: string;
    isDevelopmentBuild: boolean;
    /** What the mode shows: the sidebar badge and the tab-title prefix. */
    modeDisplay: ModeDisplay;
}>;

const mode = process.env.BUN_PUBLIC_BOS_MODE;
const apiBaseUrl = process.env.BUN_PUBLIC_API_BASE_URL ?? '';

export const env: Env = Object.freeze({
    mode,
    apiBaseUrl,
    buildCommit: process.env.BUN_PUBLIC_BUILD_COMMIT?.trim() ?? '',
    isDevelopmentBuild: IS_DEVELOPMENT_BUILD,
    modeDisplay: Object.freeze(getModeDisplay(mode, apiBaseUrl)),
});
